<template>
  <form ref="form">
    <b-message type="is-primary">
      {{ $t("translatorBillingExplained") }}
    </b-message>
    <b-field :label="$t('iban')">
      <b-input v-model="formData.iban" required />
    </b-field>
    <b-field :label="$t('bic')">
      <b-input v-model="formData.bic" required />
    </b-field>
    <b-field v-if="isVatCountry" :label="$t('vatId')">
      <b-input v-model="formData.vatId" :required="!isGermany" :placeholder="isGermany ? $t('optional') : ''" />
    </b-field>
    <b-field class="mt-4">
      <b-checkbox v-if="!isVatCountry" v-model="formData.checkbox" :required="!isVatCountry || isGermany">
        {{ $t("confirmNoVat") }}
      </b-checkbox>
    </b-field>
    <b-field class="mt-4" :grouped="true" :group-multiline="true">
      <b-button
        class="control"
        type="is-primary"
        icon-left="content-save-outline"
        :loading="isLoading"
        :disabled="!valid"
        @click="saveSettings"
      >
        {{ $t("saveSettings") }}
      </b-button>
    </b-field>
  </form>
</template>

<script>
import { VAT_COUNTRY_LIST } from "@/env";
import { functions } from "@/firebase";
import cloneDeep from "clone-deep";
export default {
  name: "TranslatorBilling",
  props: {
    translator: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isLoading: false,
      valid: true,
      formData: {
        bic: "",
        iban: "",
        checkbox: false,
        vatId: "",
        legalCountry: "",
      },
    };
  },
  computed: {
    isVatCountry() {
      return VAT_COUNTRY_LIST.includes(this.formData.legalCountry.toUpperCase());
    },
    isGermany() {
      return this.formData.legalCountry == "de";
    },
    // returns true if vat requirement is met
    vatRequirement() {
      if (this.isVatCountry) {
        if (this.isGermany) {
          // vat id is optional in germany
          return true;
        }
        if (this.formData.vatId !== "") {
          // only true if vat id is given
          return true;
        }
        return false;
      } else {
        if (this.formData.checkbox) {
          // check if checked
          return true;
        }
        return false;
      }
    },
  },
  watch: {
    isVatCountry() {
      if (this.isVatCountry) {
        this.formData.vatId = "";
      } else {
        this.formData.checkbox = false;
      }
    },
    translator: {
      handler() {
        this.formData = cloneDeep(this.translator);
      },
    },
    formData: {
      deep: true,
      handler() {
        if (this.$refs) {
          this.valid = this.$refs.form.checkValidity();
        }
      },
    },
  },
  methods: {
    async saveSettings() {
      try {
        this.isLoading = true;
        this.$emit("save", true);
        await functions.httpsCallable("SetTranslatorPaymentData")({
          iban: this.formData.iban || "",
          bic: this.formData.bic || "",
          vatId: this.formData.vatId || "",
          checkbox: this.formData.checkbox || false,
          isVatCountry: this.isVatCountry,
          isGermany: this.isGermany,
        });
        this.$buefy.toast.open({
          type: "is-success",
          message: this.$t("settingsSaved"),
        });
      } catch (error) {
        this.$buefy.toast.open({
          type: "is-danger",
          message: error,
        });
      } finally {
        this.isLoading = false;
        this.$emit("save", false);
      }
    },
  },
};
</script>

<style></style>
